import React, {Component} from "react";
import PropTypes from "prop-types";
import "bootstrap";
import {connect} from "react-redux";
import i18next from "i18next";
import {withRouter} from 'react-router';
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam.js";
import PopupWrapper from "../Common/PopupWrapper";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";

class CopyRequestForm extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {};
    }

    componentDidMount() {
        console.log("CopyRequestForm mount");
        this.onInit();
    }

    componentWillUnmount() {
        console.log("CopyRequestForm unmount");
    }

    onInit = async () => {
        try {
            //console.log(`this.props.rowKey: ${JSON.stringify(this.props.rowKey)} this.props.addMode: ${this.props.addMode}`);
            this.setState({isDataReady: false});

            await this.props.dispatch(this.props.WorkHolReq_POx_CopyReq.reset());
            await this.props.dispatch(this.props.WorkHolReq_POx_CopyReq.initialize(this.props.rowKey, {
                refresh: false, withParams: true, newItem: true
            }));

            if (!this.props.WorkHolReq_POx_CopyReq.isError) {
                this.setState({isDataReady: true});
            }
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    copyRequest = async (event) => {
        try {
            const key = {
                FromReqIntId: this.props.rowKey.ReqIntId,
                ToWorkDate: this.props.WorkHolReq_POx_CopyReq_Params.getField(0, 'ToWorkDate'),
                ToWorkComment: this.props.WorkHolReq_POx_CopyReq_Params.getField(0, 'ToWorkComment')
            };
            await this.props.dispatch(this.props.WorkHolReq_POx_CopyReq.execute(key, {withParams: true}));
            if (!this.props.WorkHolReq_POx_CopyReq.isError) {
                const toReqIntId = this.props.WorkHolReq_POx_CopyReq_Params.getField(0, 'ToReqIntId');
                console.log('toReqIntId: ' + toReqIntId);
                this.onClose(null, toReqIntId ? {ReqIntId: toReqIntId} : null);
            }
        } catch (e) {
            await this.props.dispatch(e);
        }
    }

    renderParams = (h) => {
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map(fld => {
                    let control = h.ed(fld.Name);
                    if (fld.fieldInfo.Name === 'ToWorkComment') {
                        control = <textarea
                            className="form-control"
                            style={{height: 100}}
                            value={this.props.WorkHolReq_POx_CopyReq_Params.getField(0, 'ToWorkComment')}
                            onChange={(e) => {
                                this.props.dispatch(this.props.WorkHolReq_POx_CopyReq_Params.setField(0, 'ToWorkComment', e.target.value))
                            }}
                        />
                    }
                    return (<React.Fragment key={fld.fieldInfo.Name}>
                        <div className="row">
                            <div className="col-md-3 text-md-right field-title">
                                {h.lbl(fld.Name)}
                            </div>
                            <div className="col-md-9">
                                {control}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }

    onClose = (e, rowKey) => {
        if (this.props.onClose) this.props.onClose(rowKey);
    }

    render() {
        /*
            if (!this.state.isDataReady)
              return null;
        */

        const renderButtons = () => {
            return (<div className="modal-footer text-right">
                <button type="button" disabled={!this.state.isDataReady}
                        className="btn btn-regular -goahead  ml1ex" data-dismiss="modal"
                        onClick={this.copyRequest}>{i18next.t("RVD_CopyRequest")}</button>
                <button type="button" className="btn btn-regular ml1ex" data-dismiss="modal"
                        onClick={(e) => this.onClose(e, null)}>{i18next.t("Close")}</button>
            </div>)
        }
        return (<PopupWrapper popupVisible={true} title={i18next.t('RVD_CopyRequest')}
                              instructionId="CopyRequestForm" renderButtons={renderButtons}
                              onClose={this.props.onClose} maxWidthBody="600px">
                <div>
                    {!this.state.isDataReady ? i18next.t('LoadingLabel') :
                        <PlaceholderWrapper placeholderId="CopyRequestForm_10" showHeaderTitle={false} canCollapse={false}
                                            showInstruction={false}
                                            showSplitterLine={false}>
                            <ComplexParam dataItem={this.props.WorkHolReq_POx_CopyReq_Params}
                                          parentDataItem={this.props.WorkHolReq_POx_CopyReq}
                                          showSearchBar={false} showApplyButton={false} autoApplyParams={false}
                                          renderParams={this.renderParams}/>
                        </PlaceholderWrapper>}
                </div>
            </PopupWrapper>)
    }
}

CopyRequestForm.propTypes = {
    dispatch: PropTypes.func.isRequired, WorkHolReq_POx_CopyReq: PropTypes.object, rowKey: PropTypes.object
};

CopyRequestForm.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        WorkHolReq_POx_CopyReq: state.rvdState.WorkHolReq_POx_CopyReq,
        WorkHolReq_POx_CopyReq_Params: state.rvdState.WorkHolReq_POx_CopyReq_Params
    }
}

export default withRouter(connect(mapStateToProps)(CopyRequestForm));